import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	more: {
		id: 'servicedesk-sla-settings.metrics.summary-with-actions.more',
		defaultMessage: 'More',
		description: 'label for more icon',
	},
	editMetric: {
		id: 'servicedesk-sla-settings.metrics.summary-with-actions.edit-metric',
		defaultMessage: 'Edit',
		description: 'label for edit metric',
	},
	deleteMetric: {
		id: 'servicedesk-sla-settings.metrics.summary-with-actions.delete-metric',
		defaultMessage: 'Delete',
		description: 'label for delete metric',
	},
	closeMetric: {
		id: 'servicedesk-sla-settings.metrics.summary-with-actions.close-metric',
		defaultMessage: 'Collapse metric',
		description: 'label for close metric icon',
	},
	expandMetric: {
		id: 'servicedesk-sla-settings.metrics.summary-with-actions.expand-metric',
		defaultMessage: 'Expand metric',
		description: 'label for expand metric icon',
	},
	goals: {
		id: 'servicedesk-sla-settings.metrics.summary-with-actions.goals',
		defaultMessage: 'goals',
		description: 'label for goals',
	},
	goal: {
		id: 'servicedesk-sla-settings.metrics.summary-with-actions.goal',
		defaultMessage: 'goal',
		description: 'label for goal',
	},
	errorTooltip: {
		id: 'servicedesk-sla-settings.metrics.summary-with-actions.error-tooltip',
		defaultMessage: 'This SLA has one or more errors.',
		description:
			'message displayed in tooltip when a priority gets updated and still old value is being in a SLA',
	},
});
